import { useTemplates } from "@ip-modules/contract";

import Select from "../index";

export default function Temlate(props) {
  const { templates } = useTemplates();

  const items = [...new Set(templates?.map((item) => item.status))];

  return <Select label="Status" items={items} {...props} />;
}
